import { Box, Collapse, FormControlLabel, Link, Paper, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { ConsentContext } from "./provider.js";
import { ConsentInternalApiContext } from "./internal-api.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const DetailGroup = ({ group }) => {
    const { t } = useTranslation("c-user-consent-management");
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const backgroundColor = isAtLeastSm ? "white" : theme.palette.primary.main;
    const color = isAtLeastSm ? theme.palette.primary.dark : "white";
    const borderColor = isAtLeastSm ? "white" : theme.palette.primary.dark;
    const { description, id, name, required } = group;
    const [expanded, setExpanded] = React.useState(false);
    const toggleExpanded = () => setExpanded((curr) => !curr);
    const { processes } = React.useContext(ConsentContext);
    const { addGroup, addGrant, grants, hasGrant, removeGrant, removeGroup } = React.useContext(ConsentInternalApiContext);
    const groupProcesses = processes.filter(({ group: groupId }) => group.id === groupId);
    const groupProcessIds = groupProcesses.map(({ id }) => id);
    const groupChecked = grants.some(({ id }) => groupProcessIds.includes(id));
    const handleGroupChange = (event) => {
        if (event.target.checked) {
            addGroup(group);
        }
        else {
            removeGroup(group);
        }
    };
    const TH_STYLE = {
        ...theme.typography.caption,
        color: theme.palette.primary.dark,
        maxWidth: "35vw",
        minWidth: "35vw",
        width: "35vw",
        wordBreak: "break-all",
    };
    const TD_STYLE = {
        ...theme.typography.caption,
        color: theme.palette.primary.dark,
    };
    return (React.createElement(Box, { component: "li", key: `details-group-${id}`, sx: {
            px: 3,
            py: { xs: 1.5, sm: 3 },
            color,
            backgroundColor,
            border: `1px solid ${borderColor}`,
            borderRadius: "8px",
        } },
        React.createElement(Stack, { direction: "row", alignItems: "baseline", justifyContent: "space-between" },
            React.createElement(Typography, { component: "div", role: "heading", variant: "h5", sx: { pt: 0, pb: 1.5 } },
                name,
                " (",
                groupProcesses.length,
                ")"),
            !required && (React.createElement(FormControlLabel, { control: React.createElement(Switch, { "data-testid": "group-switch", checked: groupChecked, onChange: handleGroupChange, sx: isAtLeastSm
                        ? {}
                        : {
                            ".MuiSwitch-track": { backgroundColor: "white !important" },
                            ".MuiSwitch-thumb": { color: "white !important" },
                        } }), label: groupChecked ? "An" : "Aus", labelPlacement: "start" }))),
        React.createElement(Typography, { variant: "body1", component: "div" }, description),
        React.createElement(Link, { component: "button", onClick: toggleExpanded, sx: {
                fontWeight: 500,
                letterSpacing: "0.025em",
                pt: 2,
            }, underline: "hover", variant: "caption" },
            t("details", "Details"),
            " ",
            expanded ? t("hide", "ausblenden") : t("show", "anzeigen")),
        React.createElement(Collapse, { in: expanded },
            React.createElement(Stack, { direction: "column", spacing: 3, sx: { mt: 3 } }, groupProcesses.map(({ id, name, privacyPolicyUrl, provider, purpose, required }) => {
                const checked = hasGrant({ id });
                const handleChange = (event) => {
                    if (event.target.checked) {
                        addGrant({ id });
                    }
                    else {
                        removeGrant({ id });
                    }
                };
                return (React.createElement(TableContainer, { component: Paper, key: `detail-${group.id}-${id}`, sx: { background: "white", color: theme.palette.primary.dark } },
                    React.createElement(Table, { "aria-label": name, size: "small" },
                        React.createElement(TableBody, null,
                            !required && (React.createElement(TableRow, null,
                                React.createElement(TableCell, { component: "th", scope: "row", sx: TH_STYLE }, t("accept", "Akzeptieren")),
                                React.createElement(TableCell, { sx: TD_STYLE },
                                    React.createElement(FormControlLabel, { componentsProps: { typography: { variant: "caption" } }, control: React.createElement(Switch, { checked: checked, onChange: handleChange }), "data-testid": id, label: checked ? "An" : "Aus", labelPlacement: "start", sx: { ml: 0 } })))),
                            React.createElement(TableRow, { sx: { "td, th": { borderColor: backgroundColor } } },
                                React.createElement(TableCell, { component: "th", scope: "row", sx: TH_STYLE }, t("name", "Name")),
                                React.createElement(TableCell, { sx: TD_STYLE }, name)),
                            React.createElement(TableRow, { sx: { "td, th": { borderColor: backgroundColor } } },
                                React.createElement(TableCell, { component: "th", scope: "row", sx: TH_STYLE }, t("provider", "Anbieter")),
                                React.createElement(TableCell, { sx: TD_STYLE }, provider)),
                            React.createElement(TableRow, { sx: { "td, th": { borderColor: backgroundColor } } },
                                React.createElement(TableCell, { component: "th", scope: "row", sx: TH_STYLE }, t("purpose", "Zweck")),
                                React.createElement(TableCell, { sx: TD_STYLE }, purpose)),
                            React.createElement(TableRow, { sx: { "&:last-child td, &:last-child th": { border: 0 } } },
                                React.createElement(TableCell, { component: "th", scope: "row", sx: TH_STYLE }, t("privacy-policy", "Datenschutzerklärung")),
                                React.createElement(TableCell, { sx: TD_STYLE }, privacyPolicyUrl))))));
            })))));
};
//# sourceMappingURL=detail-group.js.map